<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main custom-price-modal">
      <div class="title-area" id="modal-moving">
        <h2>特注価格設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="main-area">
        <span>{{ spaceObjName + '（id:' + form.spaceId + '）'}}</span>
        <div class="data-area">
          <ul>
            <li>
              <span class="label">参照タイプ</span>
              <div class="input-area">
                <span><label><input type="radio" v-model.number="form.priceType" value="1">直値</label></span>
                <span><label><input type="radio" v-model.number="form.priceType" value="2">直計算</label></span>
              </div>
            </li>
            <li>
              <span class="label">計算タイプ</span>
              <div class="input-area">
                <select class="select" v-model="form.calcType" @change="changeCalcType" :disabled="isPriceStatic">
                  <option v-for="(type, index) in calcTypeList" :key=index :value="type.code">
                    {{type.label}}
                  </option>
                </select>
              </div>
            </li>
            <li>
              <span class="label">使用数値タイプ</span>
              <div class="input-area">
                <select class="select" v-model="form.inputType" :disabled="isPriceStatic || form.calcType === 0">
                  <option v-for="(type, index) in dispInputTypeList" :key=index :value="type.code">
                    {{type.label}}
                  </option>
                </select>
              </div>
            </li>
            <li>
              <span class="label">価格</span>
              <div class="input-area">
                <input class="input" type="number" v-model="form.value" />円
              </div>
            </li>
          </ul>
        </div>
        <div class="errormessage-area">
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['priceType'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['inputType'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['calcType'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['value'] }}</p>
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updatePrice">更新</button>
        <button type="button" class="main_btn" @click="onCancel">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetCustomPriceModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      form: {
        spaceId: '',
        priceKind: '',
        priceType: '',
        calcType: '',
        inputType: '',
        value: ''
      },
      calcTypeList: [
        {code: 0, label: 'なし'},
        {code: 1, label: 'メートル(ｍ)'},
        {code: 2, label: 'へーべー(ｍ²)'},
        {code: 3, label: 'リューベー(ｍ³)'}
      ],
      inputTypeList: [
        {code: 0, label: 'なし', calcType: 0},
        {code: 1, label: 'Wサイズ', calcType: 1},
        {code: 2, label: 'Hサイズ', calcType: 1},
        {code: 3, label: 'Dサイズ', calcType: 1},
        {code: 4, label: 'WHサイズ', calcType: 2},
        {code: 5, label: 'WDサイズ', calcType: 2},
        {code: 6, label: 'HDサイズ', calcType: 2},
        {code: 7, label: 'WHDサイズ', calcType: 3}
      ],
      dispInputTypeList: [],
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    priceDataList: function () {
      return this.fileData.customPriceList
    },
    isPriceStatic: function () {
      return this.form.priceType === 1
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    isPriceStatic: function () {
      if (this.isPriceStatic) {
        this.form.calcType = 0
        this.form.inputType = 0
        this.dispInputTypeList = this.inputTypeList
      }
    }
  },
  methods: {
    /** 任意コメントモーダル表示 */
    showModal: function () {
      this.clearData()
      this.modalShown = true
      if (this.focusedMenuSpace != null) {
        this.form.spaceId = this.focusedMenuSpace.id
      } else {
        this.form.spaceId = this.editCtrlSpaces[0].id
      }
      this.changePriceKind()
      let obj = this.fileData.objectDataModelList.find(obj => obj.spaceId === this.form.spaceId)
      this.spaceObjName = obj.objName
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** コメント更新 */
    updatePrice: function () {
      if (!this.valid()) return
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/custom-price/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          this.validateErrorMessages = {}
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** 価格種別変更時 */
    changePriceKind: function () {
      const priceData = this.priceDataList.find(price => {
        return price.spaceId === this.form.spaceId && price.priceKind === this.form.priceKind
      })
      if (priceData) {
        this.form.priceType = priceData.priceType
        this.form.inputType = priceData.priceInputType
        this.form.calcType = priceData.priceCalcType
        this.form.value = priceData.priceValue
      } else {
        this.form.priceType = ''
        this.form.calcType = 0
        this.form.inputType = 0
        this.form.value = 0
      }
    },
    /** 計算タイプ変更時 */
    changeCalcType: function () {
      if (this.form.calcType === 1) {
        this.dispInputTypeList = this.inputTypeList.filter(c => c.calcType >= this.form.calcType)
      } else if (this.form.calcType === 2 || this.form.calcType === 3) {
        this.dispInputTypeList = this.inputTypeList.filter(c => c.calcType === this.form.calcType)
      } else {
        this.dispInputTypeList = this.inputTypeList
      }
    },
    /** 入力チェック */
    valid: function () {
      let validList = []
      validList.push(this.validValue(true, this.form.priceType, 'priceType', '参照タイプ'))
      validList.push(this.validValue(!this.isPriceStatic, this.form.inputType, 'inputType', '使用数値タイプ'))
      validList.push(this.validValue(!this.isPriceStatic, this.form.calcType, 'calcType', '計算タイプ'))
      validList.push(this.validValue(true, this.form.value, 'value', '価格'))
      let isVarid = true
      validList.forEach(e => {
        if (!e) isVarid = e
      })
      return isVarid
    },
    /** バリデーション */
    validValue: function (flg, value, key, errorMessage) {
      if (flg && (value === '' || value <= 0)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'を入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    clearData: function () {
      this.form = {
        spaceId: '',
        priceKind: 1,
        priceType: '',
        calcType: 0,
        inputType: 0,
        value: 0
      }
      this.dispInputTypeList = this.inputTypeList
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-price-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
  padding-top: 20px;
}
.data-area{
  min-height: 150px;
  margin: 10px auto;
  padding: 10px 120px;
  li{
    margin-bottom: 20px;
    div{
      width: 175px;
      display: inline-block;
      padding: 10px;
      text-align: left;
    }
    .label{
      min-width: 160px;
      display: inline-block;
      text-align: left;
      font-weight: bold;
    }
    .input-area{
      width: 180px;
      padding: 10px;
      .select{
        width: 160px;
      }
      .input{
        width: 134px;
      }
    }
  }
}
.errormessage-area{
  text-align: left;
  padding: 10px 140px;
}
.error_message {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetCustomPriceModal.vue